/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TranslationInputs */

const en_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translation`)
};

const fr_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduction`)
};

const de_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung`)
};

const it_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traduzione`)
};

const ru_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перевод`)
};

const es_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traducción`)
};

const zh_cn2_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译`)
};

const ja_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳`)
};

const hi_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद`)
};

const pt_pt2_translation = /** @type {(inputs: TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tradução`)
};

/**
* | output |
* | --- |
* | "Translation" |
*
* @param {TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation = /** @type {((inputs?: TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation(inputs)
	if (locale === "de") return de_translation(inputs)
	if (locale === "it") return it_translation(inputs)
	if (locale === "ru") return ru_translation(inputs)
	if (locale === "es") return es_translation(inputs)
	if (locale === "zh-CN") return zh_cn2_translation(inputs)
	if (locale === "ja") return ja_translation(inputs)
	if (locale === "hi") return hi_translation(inputs)
	if (locale === "pt-PT") return pt_pt2_translation(inputs)
	return en_translation(inputs)
});